angular.module('screenLoaderMod')
  .directive('screenLoader', screenLoader);

function screenLoader(){
  var directive = {
    restrict: 'EA',
    templateUrl: '/offline-checker/directives/screenLoader',
    scope: {

    },
    link: linkFunc,
    controller: screenLoaderController,
    controllerAs: 'vm',
    bindToController: true
  };

  return directive;
}

screenLoaderController.$inject = ['$scope'];

function screenLoaderController($scope) {
  var vm = this;
}

function linkFunc() {
  
}
